import React from 'react'
import { withStyles } from 'material-ui/styles'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import * as fund from 'actions/fund'
import Donut from 'components/Donut'
import { colors } from 'components/Dashboard'
import { set, cloneDeep } from 'lodash'

const styles = theme => ({
  donut: {
    textAlign: 'center',
  },
})

class Admin extends React.Component {
  componentWillMount() {
    this.props.loadAllAccounts()
  }
  render() {
    const { classes, funds, state } = this.props
    if (!funds) {
      return null
    }
    const accounts = Object.keys(funds)
    return (
      <div className={classes.root}>
        <Typography type="display2" color="accent">
          Admin
        </Typography>
        <Grid container>
          {accounts.map(a => (
            <Grid item xs={12} sm={6} md={3} lg={2} className={classes.donut}>
              <Donut
                funds={selectors.fundsWithValueMergedByCrypto(
                  set(cloneDeep(state), 'fund.funds', funds[a])
                )}
                height={300}
                colors={colors}
              />
              <Typography>
                {a} ({Object.keys(funds[a]).length} founds)
              </Typography>
            </Grid>
          ))}
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  funds: selectors.allAccounts(state),
  state: { ...state },
})

const mapDispatchToProps = dispatch => ({
  loadAllAccounts: () => dispatch(fund.loadAllAccounts()),
})

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Admin)
)



// WEBPACK FOOTER //
// ./src/components/Admin.js